module.exports = __webpack_public_path__ + "img/case-logo-52.0162a4f7.png";